const TokenKey = "longyi-token";
const OperatorKey = "longyi-Operator";
const MenusKey = "longyi-Menus";
const VehiclesKey = "longyi-Vehicles";
const RSAPuKey = "longyi-RSAPuKey"
const flagD = "longyi-flagD"
//sessionStorage sessionStorage
export function setFlagD(val){
  return sessionStorage.setItem(flagD,val);
}

export function getFlagD(){
  return sessionStorage.getItem(flagD);
}

export function setRSAPuKey(key) {
  return sessionStorage.setItem(RSAPuKey, key);
}

export function getRSAPuKey(){
  return sessionStorage.getItem(RSAPuKey);
}

export function getToken() {
  // return "ABCDEFG123456";
  return sessionStorage.getItem(TokenKey);
}

export function setToken(token) {
  return sessionStorage.setItem(TokenKey, token);
}

export function removeToken() {
  return sessionStorage.removeItem(TokenKey);
}

export function setOperator(OperatorID) {
  return sessionStorage.setItem(OperatorKey, OperatorID);
}

export function setMenus(menus) {
  return sessionStorage.setItem(MenusKey, menus);
}

export function getMenus() {
  return sessionStorage.getItem(MenusKey);
}
export function setVehicles(menus) {
  return sessionStorage.setItem(VehiclesKey, menus);
}

export function getVehicles() {
  return sessionStorage.getItem(VehiclesKey);
}

export function getOperator() {
  return sessionStorage.getItem(OperatorKey);
}

export function removeOperator() {
  return sessionStorage.removeItem(OperatorKey);
}

export function removeMenus() {
  return sessionStorage.removeItem(MenusKey);
}
